module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_3009.7170a408.png";